import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { RotateCcwIcon } from 'lucide-react'
import { useSelector } from 'react-redux'

import { selectIsEmpty } from '@/store/beneficiary-list-filters/selectors'
import { reset } from '@/store/beneficiary-list-filters/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function ResetFiltersWrapper() {
  const dispatch = useStoreDispatch()
  const loading = useStoreState((state) => state.beneficiaryList.loading)
  const isEmpty = useSelector(selectIsEmpty)
  const handleReset = () => dispatch(reset())
  return <ResetFilters onReset={handleReset} disabled={isEmpty || loading} />
}

function ResetFilters({ disabled, onReset }: { disabled: boolean; onReset: () => void }) {
  const { tc } = useT()
  return (
    <TooltipWrapper content={tc('removeFilters', { cfl: true })}>
      <Button size="icon" variant="outline" onClick={onReset} disabled={disabled}>
        <RotateCcwIcon className="size-4" />
      </Button>
    </TooltipWrapper>
  )
}
